/* AMES — Ricerca: indici statici per lingua davanti alla ricerca di Shopify.
 *
 * L1:    ames-l1-<lingua>.json (collezioni vive, marchi, risposte rapide, sinonimi), al primo focus.
 * Codici: ames-cod-NNN.json, solo quando la domanda ha forma da codice ("Codice trovato").
 * L2:    /search/suggest.json, solo collezioni (i suoi prodotti pesavano 18-35 KB e venivano buttati).
 * Set completo: /search?view=sugg (templates/search.sugg.liquid), 24 prodotti con tipo ed etichette,
 *        cercati con la domanda riscritta dai sinonimi; da qui la categoria in cui cadono i risultati.
 * Il livello L3 (backend sul PC dell'ufficio via tunnel) e' spento dal 19/10/2026: teneva appesa
 * ogni domanda per 9 secondi. Vedi md_ingest/ricerca/piano.md.
 */
(function () {
  'use strict';

  /* ── Indici della ricerca (19/10/2026, md_ingest/ricerca/piano.md) ─────────
     Tutto quello che la tendina e la pagina dei risultati sanno senza chiedere
     a Shopify sta in file statici sul CDN, uno per lingua, generati da
     md_ingest/ricerca/genera_indici.py:
       - ames-l1-<lingua>.json: collezioni vive col titolo tradotto, marchi con
         la loro collezione, risposte rapide, sinonimi e intenti;
       - ames-coll-map-<lingua>.json: etichetta del prodotto -> collezione;
       - ames-cod-NNN.json: codici articolo ed EAN -> prodotti, in 128 file
         scelti con FNV-1a dei primi 3 caratteri (stesso calcolo nello script).
     Shopify resta il motore: regge refusi e plurali ed e' sempre aggiornato.
     Questi indici gli stanno davanti per capire la domanda. */
  var IDX = (function () {
    var LINGUA = window.__AMES_LINGUA || 'it';
    var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var pL1 = null, pMap = null, l1 = null, mappa = null, fileCod = {};
    function json(u) { return fetch(u, { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : null; }); }
    /* stessa normalizzazione di md_ingest/ricerca/controlla_sinonimi.py: le chiavi
       dei sinonimi sono scritte cosi' ("tasma amerykanska") */
    function norm(s) {
      return String(s || '').toLowerCase().replace(/ł/g, 'l').normalize('NFD').replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9؀-ۿĀ-ſ\s]/g, ' ').replace(/\s+/g, ' ').trim();
    }
    function caricaL1() {
      if (!pL1) pL1 = json(window.__AMES_L1_URL || (ROOT + 'assets/ames-l1-it.json'))
        .then(function (d) { l1 = d || { collections: [], vendors: [], faq: [], syn: {} }; return l1; })
        .catch(function () { l1 = { collections: [], vendors: [], faq: [], syn: {} }; return l1; });
      return pL1;
    }
    function caricaMappa() {
      if (!pMap) pMap = json(window.__AMES_COLL_MAP_URL || (ROOT + 'assets/ames-coll-map-it.json'))
        .then(function (d) { mappa = d || {}; return mappa; }).catch(function () { mappa = {}; return mappa; });
      return pMap;
    }
    function contiene(n, w) { return (' ' + n + ' ').indexOf(' ' + w + ' ') !== -1; }
    /* Sinonimi e intenti della lingua (sinonimi_fonte.json):
       - sostituzione: gergo che il catalogo non usa -> parola del catalogo,
         la domanda si riscrive e lo si dice al cliente;
       - equivalenza: due forme dello stesso oggetto, si cerca "a OR b";
       - intento: un lavoro o un bisogno -> 1-3 categorie da proporre in testa. */
    /* toglie dalla domanda (parole come le ha scritte il cliente) quelle che
       formano la chiave: "punta ferro 8 mm" senza "punta ferro" -> "8 mm" */
    function resto(testo, chiave) {
      var kt = chiave.split(' ');
      return String(testo || '').trim().split(/\s+/).filter(function (t) {
        var nt = norm(t);
        return nt && !nt.split(' ').every(function (x) { return kt.indexOf(x) !== -1; });
      });
    }
    var UNITA = ' mm cm m mt v w kw kg ah l lt bar nm hp cc volt watt pollici inch da di per con a de do for the ';
    function soloMisure(parole) {
      return parole.every(function (w) {
        var n = norm(w);
        if (!n) return true;
        if (/^\d+([.,x\/]\d+)*[a-z"]{0,3}$/.test(n.replace(/ /g, ''))) return true;
        if (UNITA.indexOf(' ' + n + ' ') !== -1) return true;
        return ((l1 && l1.vendors) || []).some(function (v) { return norm(v.name).replace(/ /g, '') === n.replace(/ /g, ''); });
      });
    }
    function analizza(q) {
      var S = (l1 && l1.syn) || {}, n = norm(q), qs = q, nota = null, intenti = [], riconosciuta = false;
      var sost = S.sostituzioni || {}, sole = S.sole || [];
      var chiavi = Object.keys(sost).sort(function (a, b) { return b.length - a.length; });
      for (var i = 0; i < chiavi.length; i++) {
        var k = norm(chiavi[i]);
        if (!k || !contiene(n, k)) continue;
        var arrivo = sost[chiavi[i]], r = resto(q, k), nr = norm(r.join(' '));
        /* la parola d'arrivo c'e' gia' ("chiave brugola"): niente "chiave a chiave a brugola" */
        var gia = norm(arrivo).split(' ').some(function (w) { return w.length >= 4 && contiene(nr, w); });
        /* chiave che nel catalogo e' anche un nome di linea ("Safe Flex", "FlexTorq"):
           si riscrive solo da sola, con misure o con un marchio ("flex 125", "flex makita") */
        var ambigua = sole.indexOf(chiavi[i]) !== -1 && !soloMisure(r);
        riconosciuta = true;   /* anche se non si riscrive: le correzioni vecchie qui tacciono */
        if (!gia && !ambigua) {
          qs = (arrivo + ' ' + r.join(' ')).trim();
          nota = { da: q, a: qs };
        }
        break;
      }
      /* equivalenze: "(nastro telato 50mm) OR (nastro americano 50mm)"; le forme
         restano come nei titoli, con gli accenti; il trattino diventa spazio
         perche' nella sintassi di Shopify "-parola" esclude */
      var qServer = qs, nq = norm(qs), eq = S.equivalenze || [];
      for (var j = 0; j < eq.length; j++) {
        var fn = eq[j].map(norm), hit = -1;
        for (var f = 0; f < fn.length; f++) if (fn[f] && contiene(nq, fn[f])) { hit = f; break; }
        if (hit < 0) continue;
        riconosciuta = true;
        var re = resto(qs, fn[hit]).join(' ');
        qServer = eq[j].map(function (x) { return '(' + (x.replace(/-/g, ' ') + ' ' + re).trim() + ')'; }).join(' OR ');
        break;
      }
      (S.intenti || []).forEach(function (it) {
        if (intenti.length >= 2) return;
        var ok = (it.parole || []).some(function (w) { w = norm(w); return w && (contiene(n, w) || (w.indexOf(' ') !== -1 && n.indexOf(w) !== -1)); });
        if (ok) intenti.push(it);
      });
      return { q: q, qs: qs, qServer: qServer, nota: nota, intenti: intenti, riconosciuta: riconosciuta };
    }
    function collezione(h) {
      var c = ((l1 && l1.collections) || []).find(function (x) { return x.h === h; });
      return c ? { h: c.h, t: c.t, n: c.n } : null;
    }
    function contenitori() {
      var s = {};
      ((l1 && l1.collections) || []).forEach(function (c) { if (c.k) s[c.h] = 1; });
      return s;
    }
    /* Il marchio scritto da solo, anche con una lettera sbagliata, porta alla
       pagina del marchio ("dewlat", "milwakee"). */
    function dist1(a, b) {
      if (a === b) return 0;
      if (Math.abs(a.length - b.length) > 1) return 2;
      var i = 0, j = 0, d = 0;
      while (i < a.length && j < b.length) {
        if (a[i] === b[j]) { i++; j++; continue; }
        if (++d > 1) return 2;
        if (a.length > b.length) i++; else if (b.length > a.length) j++; else { i++; j++; }
      }
      return d + (a.length - i) + (b.length - j);
    }
    function marchio(q) {
      var n = norm(q).replace(/\s+/g, '');
      if (n.length < 3) return null;
      var vs = (l1 && l1.vendors) || [];
      for (var i = 0; i < vs.length; i++) {
        var v = norm(vs[i].name).replace(/\s+/g, '');
        if (!vs[i].h) continue;
        if (v === n || (n.length >= 5 && dist1(v, n) <= 1)) return vs[i];
      }
      return null;
    }
    /* Le categorie in cui cadono davvero i risultati: si contano le etichette
       di categoria dei primi 24 prodotti, senza le collezioni contenitore. */
    function categorie(prodotti) {
      if (!mappa || !prodotti || !prodotti.length) return [];
      var cont = contenitori(), conta = {}, N = Math.min(prodotti.length, 24);
      prodotti.slice(0, 24).forEach(function (p) {
        var visti = {};
        (p.tags || []).forEach(function (t) {
          if (t.indexOf(':') !== -1) return;
          var m = mappa[t];
          if (!m || visti[m.h] || cont[m.h]) return;
          visti[m.h] = 1;
          (conta[m.h] = conta[m.h] || { h: m.h, t: m.t, n: 0 }).n++;
        });
      });
      return Object.keys(conta).map(function (k) { return conta[k]; })
        .filter(function (x) { return x.n >= Math.max(2, N / 4); })
        .sort(function (a, b) { return b.n - a.n; }).slice(0, 3);
    }
    /* Codici: una domanda di 1-3 parole con un pezzo che ha lettere e cifre
       (almeno 4 caratteri), oppure 5 cifre, oppure la punteggiatura dei codici. */
    function formaCodice(q) {
      var t = String(q || '').trim().split(/\s+/);
      if (!t[0] || t.length > 3) return null;
      for (var i = 0; i < t.length; i++) {
        var c = t[i].toUpperCase().replace(/[^A-Z0-9]/g, '');
        if (c.length >= 4 && /[A-Z]/.test(c) && /\d/.test(c)) return c;
        if (/^\d{5,}$/.test(c)) return c;
        if (/[\-\/.]/.test(t[i]) && c.length >= 4 && /\d/.test(c)) return c;
      }
      return null;
    }
    function fnv(s) {
      var h = 0x811c9dc5;
      for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 0x01000193) >>> 0; }
      return h >>> 0;
    }
    function urlFile(c) {
      var n = String(fnv(c.slice(0, 3)) % 128);
      while (n.length < 3) n = '0' + n;
      var base = (window.__AMES_COD_URL || (ROOT + 'assets/ames-cod-000.json')).split('?')[0];
      return base.replace('ames-cod-000.json', 'ames-cod-' + n + '.json') + '?v=' + ((l1 && l1.cv) || '1');
    }
    function cercaCodice(q) {
      var c = formaCodice(q);
      if (!c) return Promise.resolve(null);
      return caricaL1().then(function () {
        var u = urlFile(c);
        if (!fileCod[u]) fileCod[u] = json(u).catch(function () { return {}; });
        return fileCod[u];
      }).then(function (f) {
        f = f || {};
        var esatto = f[c] || null, handles = [];
        if (esatto) handles = esatto.slice(0, 5);
        else if (c.length >= 5) {
          Object.keys(f).forEach(function (k) {
            if (handles.length < 5 && k.indexOf(c) === 0) f[k].forEach(function (h) { if (handles.length < 5 && handles.indexOf(h) < 0) handles.push(h); });
          });
        }
        if (!handles.length) return null;
        /* nome, miniatura e indirizzo nella lingua della pagina (templates/product.mini.liquid) */
        return Promise.all(handles.map(function (h) {
          return json(ROOT + 'products/' + h + '?view=mini').catch(function () { return null; });
        })).then(function (ps) {
          ps = ps.filter(Boolean);
          /* "makita 9031": il marchio scritto restringe ai suoi prodotti */
          var altre = norm(q).split(' ').filter(function (w) { return w && w.toUpperCase().replace(/[^A-Z0-9]/g, '') !== c; });
          if (altre.length) {
            var conMarchio = ps.filter(function (p) { var v = norm(p.v); return altre.some(function (w) { return v.indexOf(w) !== -1; }); });
            if (conMarchio.length) ps = conMarchio;
          }
          return ps.length ? { codice: c, esatto: !!esatto, prodotti: ps } : null;
        });
      });
    }
    return { LINGUA: LINGUA, IT: LINGUA === 'it', norm: norm, caricaL1: caricaL1, caricaMappa: caricaMappa,
             l1: function () { return l1; }, mappa: function () { return mappa; }, analizza: analizza,
             collezione: collezione, marchio: marchio, categorie: categorie, formaCodice: formaCodice,
             cercaCodice: cercaCodice };
  })();
  window.AMES_IDX = IDX;

  /* Testi delle righe nuove della tendina, nelle cinque lingue del sito. */
  var TXTS = {
    it: { cod: 'Codice trovato', codp: 'Codici che cominciano con', per: 'Risultati per', scritto: 'hai scritto', proprio: 'cerca proprio',
          cat: 'Categorie', tutti: 'Tutti i prodotti', proc: 'Non lo vediamo a catalogo: lo procuriamo noi.', procCta: 'Chiedilo nel preventivo',
          foto: 'Non sai come si chiama? Mandaci una foto', intento: 'Per questo lavoro' },
    en: { cod: 'Code found', codp: 'Codes starting with', per: 'Results for', scritto: 'you typed', proprio: 'search exactly',
          cat: 'Categories', tutti: 'All products by', proc: "We can't see it in the catalogue: we'll source it for you.", procCta: 'Ask for it in a quote',
          foto: "Don't know what it's called? Send us a photo", intento: 'For this job' },
    es: { cod: 'Código encontrado', codp: 'Códigos que empiezan por', per: 'Resultados para', scritto: 'has escrito', proprio: 'buscar exactamente',
          cat: 'Categorías', tutti: 'Todos los productos', proc: 'No lo vemos en el catálogo: lo conseguimos nosotros.', procCta: 'Pídelo en un presupuesto',
          foto: '¿No sabes cómo se llama? Envíanos una foto', intento: 'Para este trabajo' },
    pl: { cod: 'Znaleziony kod', codp: 'Kody zaczynające się od', per: 'Wyniki dla', scritto: 'wpisano', proprio: 'szukaj dokładnie',
          cat: 'Kategorie', tutti: 'Wszystkie produkty', proc: 'Nie widzimy tego w katalogu: zdobędziemy to dla Ciebie.', procCta: 'Zapytaj w wycenie',
          foto: 'Nie wiesz, jak to się nazywa? Wyślij nam zdjęcie', intento: 'Do tej pracy' },
    ar: { cod: 'تم العثور على الرمز', codp: 'رموز تبدأ بـ', per: 'نتائج', scritto: 'كتبت', proprio: 'ابحث حرفيًا',
          cat: 'الفئات', tutti: 'جميع منتجات', proc: 'لا نراه في الكتالوج: سنوفره لك.', procCta: 'اطلبه في عرض سعر',
          foto: 'لا تعرف اسمه؟ أرسل لنا صورة', intento: 'لهذا العمل' }
  };
  var TXT = TXTS[IDX.LINGUA] || TXTS.it;
  IDX.TXT = TXT;   /* li usa anche la pagina dei risultati (ames-ricerca-recupero) */

  // ─── Setup per ogni istanza del componente ───────────────────────────────
  document.querySelectorAll('[data-ames-search]').forEach(initSearch);

  /* ── Ricerche recenti ──────────────────────────────────────────────────
     A campo vuoto il menu a tendina non mostrava nulla: chi torna sul sito
     ripartiva ogni volta da zero, e su un catalogo da 40.000 referenze la
     ricerca precedente e' quasi sempre il punto da cui si riprende.
     Le query restano nel browser, non vengono inviate da nessuna parte. */
  var RECENT_KEY = 'ames_ricerche_v1', RECENT_MAX = 6;
  window.AMES_RECENT = {
    all: function () {
      try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; }
      catch (e) { return []; }
    },
    add: function (q) {
      q = String(q || '').trim();
      if (q.length < 2) return;
      var a = window.AMES_RECENT.all().filter(function (x) {
        return x.toLowerCase() !== q.toLowerCase();
      });
      a.unshift(q);
      try { localStorage.setItem(RECENT_KEY, JSON.stringify(a.slice(0, RECENT_MAX))); } catch (e) {}
    },
    clear: function () { try { localStorage.removeItem(RECENT_KEY); } catch (e) {} }
  };

  function initSearch(form) {
    const input    = form.querySelector('[data-ames-search-input]');
    const dropdown = form.querySelector('[data-ames-search-dropdown]');
    const inner    = dropdown.querySelector('.ames-search-dropdown__inner');
    const submitBtn = form.querySelector('[data-ames-search-submit]');
    const backendUrl = '';   /* L3 spento (19/10/2026): vedi l'intestazione */
    // root localizzata: i link del dropdown devono mantenere la lingua corrente
    const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const T = (k, f) => (window.AMES_I18N && window.AMES_I18N.ui && window.AMES_I18N.ui[k]) || f;
    const loc = u => (u && u[0] === '/' && u[1] !== '/') ? ROOT.replace(/\/$/, '') + u : u;
    const locS = u => (ROOT !== '/' && u && u.indexOf(ROOT) === 0) ? u : loc(u);

    // Il bottone Cerca resta sempre attivo: spegnerlo di default faceva sembrare
    // rotta la CTA principale della home. Il controllo sulla lunghezza minima vive
    // nell'onsubmit del form, che rimette il fuoco nel campo invece di non fare nulla.
    if (submitBtn) { submitBtn.disabled = false; submitBtn.removeAttribute('aria-disabled'); }

    let l1Data = null;
    let l1LoadPromise = null;
    let debounceTimer = null;
    let lastQuery = '';
    let currentAbort = null;

    // ─── L1: carica trie lazy alla prima focus ──────────────────────────────
    function ensureL1() {
      if (l1Data) return Promise.resolve(l1Data);
      if (!l1LoadPromise) l1LoadPromise = IDX.caricaL1().then(function (d) { l1Data = d; return d; });
      return l1LoadPromise;
    }
    input.addEventListener('focus', ensureL1, { once: true });

    // ─── Mappa tag → collezione di appartenenza (per i chip sui prodotti) ─────
    var collMap = null;
    function ensureCollMap() {
      if (collMap) return;
      IDX.caricaMappa().then(function (d) { collMap = d; });
    }
    input.addEventListener('focus', ensureCollMap, { once: true });

    /* ── Accessibilita' ─────────────────────────────────────────────────────
       Il campo non diceva a nessuno che sotto si apre un elenco, e le frecce
       evidenziavano voci che il lettore di schermo non annunciava. Ora il
       campo dichiara il pannello che controlla e se e' aperto, e una regione
       "polite" legge quanti risultati ci sono e quale voce e' evidenziata. */
    const uid = 'asd-' + Math.random().toString(36).slice(2, 8);
    dropdown.id = dropdown.id || uid;
    input.setAttribute('aria-controls', dropdown.id);
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-haspopup', 'true');
    const annuncio = document.createElement('p');
    annuncio.className = 'visually-hidden';
    annuncio.setAttribute('aria-live', 'polite');
    form.appendChild(annuncio);
    let ultimoAnnuncio = '';
    function annuncia(t) {
      if (t === ultimoAnnuncio) return;
      ultimoAnnuncio = t;
      annuncio.textContent = t;
    }
    /* le chip delle collezioni sono span con role=link: senza questo, con la
       tastiera si raggiungevano ma Invio non faceva nulla */
    inner.addEventListener('keydown', function (e) {
      const c = e.target.closest && e.target.closest('[data-href]');
      if (c && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault(); e.stopPropagation();
        window.location.href = c.getAttribute('data-href');
      }
    });

    // ─── Listeners ──────────────────────────────────────────────────────────
    input.addEventListener('input', onInput);
    input.addEventListener('keydown', onKeydown);
    form.addEventListener('focusout', function (e) {
      if (e.relatedTarget && form.contains(e.relatedTarget)) return;
      setTimeout(function () { if (!form.contains(document.activeElement)) hide(); }, 150);
    });
    form.addEventListener('submit', function () {
      window.AMES_RECENT.add(input.value);
      /* "flex" + Invio: si cerca "smerigliatrice angolare" e la pagina lo dice,
         con il link per cercare proprio "flex" (ames-ricerca-recupero) */
      const an = state.an;
      if (an && an.nota && normalize(input.value) === normalize(an.q)) {
        input.value = an.qs;
        let h = form.querySelector('input[name="ames_sin"]');
        if (!h) { h = document.createElement('input'); h.type = 'hidden'; h.name = 'ames_sin'; form.appendChild(h); }
        h.value = an.nota.da;
      }
    });
    input.addEventListener('focus', () => { if (!input.value.trim()) showRecent(); });
    document.addEventListener('click', e => {
      if (!form.contains(e.target)) hide();
    });

    // ─── Handlers ───────────────────────────────────────────────────────────
    function onInput() {
      const q = input.value.trim();
      if (!q) { showRecent(); return; }
      if (q.length < 2) { hide(); return; }
      if (q === lastQuery) return;
      lastQuery = q;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => runLayers(q), 120);
    }

    function onKeydown(e) {
      if (dropdown.hasAttribute('hidden') && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) return;
      const items = inner.querySelectorAll('.ames-perc__pill, .asd__item');
      const cur = inner.querySelector('.ames-perc__pill[aria-selected="true"], .asd__item[aria-selected="true"]');
      if (!items.length && e.key !== 'Escape') return;
      let idx = cur ? Array.from(items).indexOf(cur) : -1;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        idx = (idx + 1) % items.length;
        select(items, idx);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        idx = (idx - 1 + items.length) % items.length;
        select(items, idx);
      } else if (e.key === 'Enter' && cur && cur.href) {
        e.preventDefault();
        window.location.href = cur.href;
      } else if (e.key === 'Escape') {
        hide();
      }
    }

    function select(items, idx) {
      items.forEach(i => i.removeAttribute('aria-selected'));
      if (items[idx]) {
        items[idx].setAttribute('aria-selected', 'true');
        items[idx].scrollIntoView({ block: 'nearest' });
        const t = items[idx].querySelector('.asd__item__title');
        annuncia((t ? t.textContent : items[idx].textContent).replace(/\s+/g, ' ').trim() +
                 ' (' + (idx + 1) + '/' + items.length + ')');
      }
    }

    /* ── Percorsi: mestiere, settore, obiettivo, "Forse cercavi" ───────────
       Vedi assets/ames-percorsi.js. Arrivano senza rete (tranne gli obiettivi,
       solo per le frasi) e stanno sopra i prodotti. */
    const PT = {
      forse:     T('did_you_mean', 'Forse cercavi'),
      mestiere:  T('perc_mestiere', 'Per mestiere'),
      settore:   T('perc_settore', 'Per settore'),
      obiettivo: T('perc_obiettivo', 'Per obiettivo'),
      categorie: T('perc_categorie', 'Categorie')
    };
    function percorsi(q) {
      state.perc = ''; state.percRaw = null;
      if (!window.AMES_PERCORSI || !IDX.IT) return;
      window.AMES_PERCORSI.trova(q).then(function (r) {
        if (q !== lastQuery || !r) return;
        state.percRaw = r;
        state.perc = window.AMES_PERCORSI.html(r, PT);
        if (state.perc) render(q, null, null, null);
      }).catch(function () {});
    }

    /* Quarto livello: la ricerca vera del negozio.
       La ricerca predittiva di Shopify si ferma a cinque prodotti qualunque
       limite si chieda (misurato: limit=20 ne restituisce 5), e l'indice
       locale non copre le domande comuni. Questo chiede al negozio la sua
       ricerca con la sua rilevanza, in JSON e senza layout
       (templates/search.sugg.liquid): ventiquattro prodotti in ~17 KB, mezzo
       secondo. Arriva dopo i primi cinque, che restano istantanei. */
    var abortTutti = null;
    async function fetchTutti(q, qServer) {
      if (abortTutti) abortTutti.abort();
      abortTutti = new AbortController();
      try {
        const r = await fetch(ROOT + 'search?view=sugg&type=product&q=' + encodeURIComponent(qServer || q),
                              { signal: abortTutti.signal, credentials: 'omit' });
        if (!r.ok) return null;
        const d = await r.json();
        return {
          total: d.n || 0,
          products: (d.p || []).map(function (x) {
            return { title: x.t, url: x.u, vendor: x.v || '', image: x.i || '', acc: x.a || [],
                     type: x.ty || '', tags: x.g || [], sku: x.s || '' };
          })
        };
      } catch (e) { return null; }
    }

    /* Prodotti dal motore nostro (assets/ames-motore.js): l'ordine lo decide
       l'indice (oggetto nel titolo, categoria, marchio, misure, codici), i dati
       da mostrare (titolo tradotto, foto, marchio) arrivano in una sola
       richiesta alla Storefront API del negozio, senza chiave. Se il motore
       non e' sicuro (nessun prodotto con l'oggetto, frasi col verbo, mestieri)
       resta la ricerca del negozio (fetchTutti). */
    async function prodottiDaHandle(hs, righe) {
      if (!hs.length) return [];
      const lang = String(IDX.LINGUA || 'it').toUpperCase();
      const campi = '{ title handle vendor featuredImage { url(transform: {maxWidth: 160, maxHeight: 160}) } }';
      const query = 'query @inContext(language: ' + lang + ') {' +
        hs.map(function (h, k) { return ' p' + k + ': product(handle: ' + JSON.stringify(h) + ') ' + campi; }).join('') + ' }';
      const r = await fetch('/api/2024-10/graphql.json', {
        method: 'POST', credentials: 'omit',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ query: query })
      });
      if (!r.ok) throw new Error('storefront ' + r.status);
      const d = (await r.json()).data || {};
      const MX = window.AMES_MX, man = MX.manifesto() || {}, at = MX.attr && (await MX.attr().catch(function () { return null; }));
      const out = [];
      hs.forEach(function (h, k) {
        const p = d['p' + k];
        if (!p) return;
        const ti = MX.tipoDi(righe[k].i);
        out.push({
          title: p.title, url: loc('/products/' + p.handle), vendor: p.vendor || '',
          image: (p.featuredImage && p.featuredImage.url) || '',
          type: (man.tipi && man.tipi[ti]) || '', tags: at && at.tipi && at.tipi[ti] ? [at.tipi[ti]] : [],
          acc: [], sku: '', mx: 1
        });
      });
      return out;
    }
    async function fetchMotore(q) {
      const MX = window.AMES_MX;
      if (!MX || !window.__AMES_MX_URL) return null;
      try {
        const r = await MX.cerca(q, { prefisso: true });
        if (!r || r.cede || !r.ok || q !== lastQuery) return null;
        const righe = r.ris.filter(function (x) { return x.ok || x.f; }).slice(0, 12);
        const hs = await MX.handles(righe.map(function (x) { return x.i; }));
        const validi = [], rv = [];
        hs.forEach(function (h, k) { if (h) { validi.push(h); rv.push(righe[k]); } });
        if (q !== lastQuery) return null;
        const prods = await prodottiDaHandle(validi, rv);
        if (!prods.length) return null;
        return { total: r.ok, products: prods, motore: r };
      } catch (e) { return null; }
    }

    // ─── Esecuzione dei 3 layer ─────────────────────────────────────────────
    async function runLayers(q) {
      // reset per-query: mai mostrare residui della query precedente
      state.l1 = null; state.l2 = null; state.l3 = null; state.tutti = null;
      state.l3Pending = false; state.cod = null; state.an = null; state.tuttiArrivato = false;
      percorsi(q);
      IDX.caricaMappa().then(function (d) { collMap = d; });
      /* i sinonimi stanno nell'indice: alla prima domanda si aspetta che arrivi
         (80 KB, 15 compressi, chiesto gia' al focus del campo) */
      if (!l1Data) { try { await ensureL1(); } catch (e) {} }
      if (q !== lastQuery) return;
      const an = IDX.analizza(q);
      state.an = an;
      if (IDX.formaCodice(q)) {
        IDX.cercaCodice(q).then(function (r) { if (q !== lastQuery || !r) return; state.cod = r; render(q, null, null, null); });
      }

      // L1: subito (5 ms)
      ensureL1().then(d => render(q, fromL1(d, q), null, null));

      // il livello completo parte subito, in parallelo: arriva dopo, non dopo gli altri
      /* Il set completo arriva mezzo secondo dopo i primi cinque. Nel frattempo
         il pannello dichiara che sta ancora cercando: senza segnale la lista si
         allunga di colpo e sembra un salto, con il segnale e' un'attesa
         annunciata. Il cambio e' una dissolvenza brevissima su opacity, che il
         browser compone sulla scheda grafica. */
      dropdown.classList.add('is-carica');
      fetchMotore(q).then(function (m) { return m || fetchTutti(q, an.qServer); }).then(function (t) {
        dropdown.classList.remove('is-carica');
        if (q !== lastQuery) return;
        state.tutti = t || { products: [] };
        state.tuttiArrivato = true;
        render(q, null, null, null);
        var g = inner.querySelector('.asd__grid');
        if (g) { g.classList.add('is-nuovo'); setTimeout(function(){ g.classList.remove('is-nuovo'); }, 260); }
      });

      // L2 + L3 in parallelo
      /* L2 solo per le collezioni; su /ar Shopify risponde 417 e non si chiama */
      if (IDX.LINGUA !== 'ar') fetchL2(an.qs).then(l2 => render(q, null, l2, null)).catch(() => {});
    }

    // ─── L1: scan locale ────────────────────────────────────────────────────
    function fromL1(d, q) {
      if (!d) return null;
      const nq = normalize(q);
      const tokens = nq.split(/\s+/).filter(Boolean);
      const match = txt => {
        const t = normalize(txt);
        return tokens.every(tok => t.includes(tok));
      };
      // FAQ: risposte rapide a domande aperte (orari, contatti, noleggio, ecc.)
      // match a PAROLE INTERE: evita falsi positivi da sottostringhe
      // (es. "info" dentro "antinfortunistiche")
      const wordHit = (query, kw) => (' ' + query + ' ').includes(' ' + kw + ' ');
      const faq = (d.faq || []).filter(f =>
        (f.keywords || []).some(k => wordHit(nq, normalize(k)))).slice(0, 3);
      // shortcuts speciali (preventivo, account, ecc)
      const shortcuts = [];
      /* categorie prima di mestieri e settori, poi per numero di prodotti */
      const ordineAsse = { c: 0, b: 1, m: 2, s: 3 };
      const collections = (d.collections || []).filter(c => match(c.t || c.title))
        .sort((a, b) => (ordineAsse[a.a] || 0) - (ordineAsse[b.a] || 0) || (b.n || 0) - (a.n || 0))
        .slice(0, 12)
        .map(c => ({ title: c.t || c.title, url: '/collections/' + (c.h || c.handle) }));
      const vendors = (d.vendors || []).filter(v => match(v.name)).slice(0, 10)
        .map(v => ({ name: v.name, url: v.h ? '/collections/' + v.h : '/search?q=' + encodeURIComponent(v.name) }));
      const products = [];
      return { products, collections, vendors, shortcuts, faq, source: 'L1' };
    }

    // ─── L2: Shopify suggest ────────────────────────────────────────────────
    async function fetchL2(q) {
      if (currentAbort) currentAbort.abort();
      currentAbort = new AbortController();
      const url = `${ROOT}search/suggest.json?q=${encodeURIComponent(q)}`
        + '&resources[type]=collection'
        + '&resources[limit]=6';
      const r = await fetch(url, { signal: currentAbort.signal, credentials: 'omit' });
      const d = await r.json();
      const res = d.resources && d.resources.results || {};
      return {
        products: (res.products || []).map(p => ({
          id: p.id, title: p.title, vendor: p.vendor || '', url: p.url,
          product_type: p.product_type || '',
          image: p.image || (p.featured_image && p.featured_image.url) || '',
          tags: p.tags || [],
        })),
        collections: (res.collections || []).map(c => ({
          id: c.id, title: c.title, url: c.url,
        })),
        articles: (res.articles || []).map(a => ({
          id: a.id, title: a.title, url: a.url,
        })),
        pages: (res.pages || []).map(p => ({
          id: p.id, title: p.title, url: p.url,
        })),
        source: 'L2',
      };
    }

    // ─── L3: backend AI (timeout 9s — a freddo embed+rerank via tunnel supera i 3.5s) ──
    function fetchL3(q) {
      const ctrl = new AbortController();
      const tout = setTimeout(() => ctrl.abort(), 9000);
      return fetch(`${backendUrl}/search/predict?q=${encodeURIComponent(q)}&k=6`, {
        signal: ctrl.signal,
        credentials: 'omit',
      })
        .then(r => r.json())
        .then(d => { clearTimeout(tout); d.source = 'L3'; return d; })
        .catch(() => { clearTimeout(tout); return null; });
    }

    // ─── Merge + render ─────────────────────────────────────────────────────
    const state = { l1: null, l2: null, l3: null, q: '' };

    function render(q, l1, l2, l3) {
      if (q !== lastQuery) return; // stale
      if (l1) state.l1 = l1;
      if (l2) state.l2 = l2;
      if (l3) state.l3 = l3;
      state.q = q;

      const html = renderHTML(state);
      inner.innerHTML = html;
      show();
      const nProd = inner.querySelectorAll('.asd__item--prod').length;
      if (nProd) annuncia(nProd + ' ' + T('sr_results', 'risultati: usa le frecce per scorrerli, Invio per aprire'));
      proponiCorrezione(q);
    }

    /* Quando il menu a tendina mostra prodotti che non c'entrano, quasi sempre
       e' un refuso o una parola che il catalogo non conosce. Prima si guardava
       il NUMERO di voci (<= 2), ma la ricerca del negozio ne restituisce sempre
       ventiquattro, anche per "xqzwk": la correzione non compariva mai. Ora si
       guarda se i titoli contengono la parola scritta. La correzione e'
       offerta, non imposta: il visitatore sta ancora scrivendo. */
    function proponiCorrezione(q) {
      if (!window.AMES_FIX || !IDX.IT) return;
      if (state.cod || state.an && (state.an.nota || state.an.riconosciuta)) return;
      if (state.percRaw && state.percRaw.forse) return;   /* c'e' gia' un "Forse cercavi" */
      const titoli = Array.prototype.map.call(
        inner.querySelectorAll('.asd__item--prod .asd__item__title'), function (x) { return x.textContent; });
      const debole = window.AMES_PERCORSI ? window.AMES_PERCORSI.deboli(q, titoli) : titoli.length <= 2;
      if (!debole) return;
      if (window.AMES_PERCORSI && window.AMES_PERCORSI.frase && window.AMES_PERCORSI.frase(q)) return;
      window.AMES_FIX.correggi(q).then(function (fix) {
        if (!fix || q !== lastQuery) return;
        if (String(fix.corretta).toLowerCase() === String(q).toLowerCase()) return;
        if (inner.querySelector('[data-asd-fix]')) return;
        var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
        var a = document.createElement('a');
        a.className = 'asd__item asd__fix';
        a.setAttribute('data-asd-fix', '');
        a.href = root + 'search?q=' + encodeURIComponent(fix.corretta) + '&type=product';
        a.innerHTML = '<span class="asd__item__title">' +
          esc(T('did_you_mean', 'Forse cercavi')) + ' <strong>' + esc(fix.corretta) + '</strong></span>';
        inner.insertBefore(a, inner.firstChild);
      }).catch(function () {});
    }

    function renderHTML(s) {
      const { l1, l2, l3, q } = s;   /* s.tutti si legge direttamente: vedi sotto */
      const parts = [];

      if (s.perc && !(s.an && (s.an.nota || s.an.riconosciuta || s.an.intenti.length))) parts.push(s.perc);
      parts.push.apply(parts, righeNuove(s));

      // FAQ — risposte rapide a domande aperte (orari/contatti/noleggio/info/personalizzazioni)
      if (l1 && l1.faq && l1.faq.length) {
        parts.push(`<div class="asd__section asd__section--faq">
          <h4>${T('quick_answer','Risposta rapida')}</h4>
          ${l1.faq.map(f => `
            <div class="asd__faq">
              <div class="asd__faq__title">${esc(f.title)}</div>
              <div class="asd__faq__snippet">${esc(f.snippet)}</div>
              <a class="asd__faq__cta" href="${esc(loc(f.url))}">${esc(f.cta || T('read_more','Leggi di più'))} <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="vertical-align:-2px"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></a>
            </div>
          `).join('')}
        </div>`);
      }

      // Intent box (solo L3)
      if (l3 && l3.intent && Object.keys(l3.intent).length) {
        const it = l3.intent;
        const bits = [];
        if (it.categoria) bits.push(`<strong>${esc(it.categoria)}</strong>`);
        if (it.vendor)    bits.push(`brand <strong>${esc(it.vendor)}</strong>`);
        if (Array.isArray(it.specifiche) && it.specifiche.length)
          bits.push(it.specifiche.map(esc).join(', '));
        if (bits.length) {
          parts.push(`<div class="asd__intent">Cerchi: ${bits.join(' · ')}</div>`);
        }
      }

      // Shortcuts (L1)
      if (l1 && l1.shortcuts && l1.shortcuts.length) {
        parts.push(section(T('quick_shortcuts','Suggerimenti rapidi'),
          l1.shortcuts.map(s => itemA(s.label, '', s.url, 'rapido'))));
      }

      // Merge prodotti: L3 (riordinati) > L2 > L1
      const prodSet = new Map();
      const addProd = p => { if (p && p.url && !prodSet.has(p.url)) prodSet.set(p.url, p); };
      (l3 && l3.products || []).forEach(addProd);
      (l2 && l2.products || []).forEach(addProd);
      (l1 && l1.products || []).forEach(addProd);
      /* Ventiquattro, non otto: il pannello ora e' alto quanto lo schermo e
         otto risultati ci lasciavano mezza pagina bianca. Su una ricerca da
         493 prodotti otto sono troppo pochi per farsi un'idea. */
      /* Quando la ricerca vera del negozio ha risposto, i prodotti sono i suoi:
         hanno la rilevanza di Shopify e sono ventiquattro invece di cinque.
         Fino ad allora restano quelli istantanei, cosi' non si guarda il vuoto. */
      /* I tre livelli arrivano con ordini diversi e nessuno dei tre e' l'ordine
         di attinenza: si riordina prima di tagliare a 24, altrimenti il taglio
         butta via prodotti piu' pertinenti di quelli che restano. La tendina
         e la pagina dei risultati usano la stessa regola (ames-rilevanza.js):
         due ordini diversi per la stessa ricerca sono un difetto, non una
         scelta. */
      const grezzi = (s.tutti && s.tutti.products.length)
        ? s.tutti.products
        : Array.from(prodSet.values());
      const products = (window.AMES_RILEVANZA && !(s.tutti && s.tutti.motore)
        ? window.AMES_RILEVANZA.ordina(q, grezzi, function (p) {
            return { title: p.title, type: p.type || p.product_type, brand: p.vendor, tags: p.tags };
          })
        : grezzi).slice(0, (window.matchMedia && matchMedia('(max-width:899px)').matches) ? 6 : 24);   /* telefono: sei, poi "Vedi tutti" */

      // Collezioni scelte: pill arrotondate, L3 > L2 > L1.
      // La chiave e' l'indirizzo ripulito piu' il titolo: i tre livelli danno la
      // stessa collezione con indirizzi leggermente diversi (con o senza
      // parametri, con o senza dominio), e nel pannello comparivano due volte
      // "Scarpe Basse Antinfortunistiche" — a catalogo di duplicati non ce
      // n'e' nessuno, era solo la fusione a non riconoscerli.
      const chiaveColl = c => {
        var u = String(c.url || '').split('?')[0].split('#')[0].replace(/\/+$/, '');
        u = u.replace(/^https?:\/\/[^/]+/, '');
        return u.split('/collections/').pop().toLowerCase() + '|' +
               String(c.title || '').trim().toLowerCase();
      };
      const collSet = new Map();
      const aggiungiColl = c => { if (!c || !c.url) return; var k = chiaveColl(c); if (!collSet.has(k)) collSet.set(k, c); };
      (l3 && l3.collections || []).forEach(aggiungiColl);
      (l2 && l2.collections || []).forEach(aggiungiColl);
      (l1 && l1.collections || []).forEach(aggiungiColl);
      const collections = Array.from(collSet.values()).slice(0, 12);

      // Brand: pill arrotondate (estratti automaticamente da L3/L1 + autocomplete L2 vendor)
      const venSet = new Map();
      (l3 && l3.vendors || []).forEach(v => { if (v.name && !venSet.has(v.name)) venSet.set(v.name, v); });
      (l1 && l1.vendors || []).forEach(v => { if (v.name && !venSet.has(v.name)) venSet.set(v.name, v); });
      // Estrai vendor anche dai prodotti L2/L3 (segnale "scelti automaticamente")
      products.forEach(p => {
        if (p.vendor && !venSet.has(p.vendor)) {
          var vm = IDX.marchio(p.vendor);
          venSet.set(p.vendor, { name: p.vendor, url: vm ? '/collections/' + vm.h : `/search?q=${encodeURIComponent(p.vendor)}` });
        }
      });
      /* "A.M.E.S. srl" e' l'anagrafica di casa per gli articoli senza marchio: come
         "marchio scelto" non dice niente al cliente */
      const vendors = Array.from(venSet.values()).filter(function (v) { return !/^a\.?\s*m\.?\s*e\.?\s*s\.?(\s|$)/i.test(v.name); }).slice(0, 10);

      // Prodotti + Collezioni/Marchi raggruppati in un unico blocco: su desktop (≥900px)
      // diventa una griglia a 2 colonne (prodotti larghi a sx, sidebar collezioni+marchi a dx),
      // su mobile resta impilato in ordine naturale (vedi CSS .asd__gridwrap).
      if (products.length || collections.length || vendors.length) {
        let gridHtml = '<div class="asd__gridwrap">';
        if (products.length) {
          gridHtml += `<div class="asd__section asd__section--products">
            <h4>${T('products','Prodotti scelti')}</h4>
            <div class="asd__grid">${products.map(itemProduct).join('')}</div>
          </div>`;
        }
        if (collections.length || vendors.length) {
          gridHtml += '<div class="asd__sidebar">';
          if (collections.length) {
            gridHtml += `<div class="asd__section asd__section--coll">
              <h4>${T('sel_collections','Collezioni scelte')}</h4>
              <div class="asd__pills asd__pills--coll">${collections.map(c =>
                `<a class="asd__pill asd__pill--coll" href="${esc(locS(c.url))}">${esc(c.title)}</a>`
              ).join('')}</div>
            </div>`;
          }
          if (vendors.length) {
            gridHtml += `<div class="asd__section asd__section--brands">
              <h4>${T('sel_brands','Marchi scelti')}</h4>
              <div class="asd__pills">${vendors.map(v =>
                `<a class="asd__pill" href="${esc(locS(v.url))}">${esc(v.name)}</a>`
              ).join('')}</div>
            </div>`;
          }
          gridHtml += '</div>';
        }
        gridHtml += '</div>';
        parts.push(gridHtml);
      }

      if (!parts.length) {
        if (!s.tuttiArrivato) {
          return '<div class="asd__empty">…</div>';
        }
        if (false) {
          // la ricerca semantica sta ancora lavorando: niente falsi "nessun risultato"
          return `<div class="asd__empty">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true" style="vertical-align:-3px;margin-right:7px;animation:asdspin 0.9s linear infinite"><path d="M21 12a9 9 0 1 1-6.2-8.56"/></svg>
            ${T('thinking','Un attimo: sto interpretando la tua richiesta…')}
            <style>@keyframes asdspin{to{transform:rotate(360deg)}}</style>
          </div>`;
        }
        return rigaProcura(q, true) + `<div class="asd__empty">
          ${T('no_results_for','Nessun risultato per')} &ldquo;${esc(q)}&rdquo;.<br>
          <a class="asd__cta" href="${loc('/pages/info')}">${T('contact_cta','Contattaci per una consulenza')} <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="vertical-align:-2px"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></a>
          <a class="asd__more" href="${esc(urlCompleta(s))}">${T('open_full_search','Apri ricerca completa')} <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="vertical-align:-2px"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></a>
        </div>`;
      }

      // CTA finali: consulenza + apri ricerca completa
      parts.push(`<div class="asd__footer">
        <a class="asd__more" href="${esc(urlCompleta(s))}">${s.tutti && s.tutti.motore ? esc(T('see_all','Vedi tutti i risultati')) + ' (' + Number(s.tutti.total).toLocaleString() + ')' : T('open_full_search','Apri ricerca completa')} <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="vertical-align:-2px"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></a>
        <a class="asd__cta" href="${loc('/pages/info')}">${T('contact_cta','Contattaci per una consulenza')} <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="vertical-align:-2px"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></a>
      </div>`);
      return parts.join('');
    }

    /* ── Righe in testa alla tendina (piano 1.1, 2.1, 2.2, 2.4) ──────────────
       1. "Codice trovato" (o "Codici che cominciano con");
       2. "Risultati per X: hai scritto Y" quando un sinonimo ha riscritto la domanda;
       3. marchio scritto da solo -> la sua pagina;
       4. intenti (un lavoro -> le sue categorie) e categorie in cui cadono i risultati;
       5. "Non lo vediamo a catalogo: lo procuriamo noi" quando i risultati non c'entrano. */
    function rigaProcura(q, sempre) {
      return '<div class="asd__procura">'
        + '<button type="button" class="asd__item asd__procura__btn" data-apri-richiesta="procurement" data-rq-testo="' + esc(q) + '">'
        + '<span class="asd__item__title">' + esc(TXT.proc) + ' <strong>' + esc(TXT.procCta) + '</strong></span></button>'
        + '<button type="button" class="asd__procura__foto" data-apri-richiesta="obiettivo" data-rq-testo="' + esc(q) + '">' + esc(TXT.foto) + '</button>'
        + '</div>';
    }
    function debole(s) {
      if (!s.tuttiArrivato || s.cod) return false;
      if (s.tutti && s.tutti.motore) return false;   /* il motore ha trovato l'oggetto della domanda */
      const prods = (s.tutti && s.tutti.products) || [];
      if (!prods.length) return true;
      if (IDX.marchio(s.q)) return false;   /* "milwakee": i prodotti sono giusti, la parola no */
      /* parole vuote delle cinque lingue; l'arabo non ha radici affidabili */
      if (IDX.LINGUA === 'ar') return false;
      const VUOTE = ' di da per con su in il lo la i gli le un una e o del della dei delle al alla ai a '
        + 'the and for with from los las del para con por una unos dla oraz lub ';
      const parole = normalize(s.an ? s.an.qs : s.q).split(' ').filter(w => w.length >= 3 && VUOTE.indexOf(' ' + w + ' ') === -1);
      if (!parole.length) return false;
      const radice = w => w.length > 5 ? w.slice(0, w.length - 2) : w;
      return !prods.slice(0, 8).some(p => {
        const t = normalize(p.title + ' ' + (p.vendor || '') + ' ' + (p.sku || ''));
        return parole.every(w => t.indexOf(radice(w)) !== -1);
      });
    }
    function urlCompleta(s) {
      if (s.an && s.an.nota) return routesSearch(s.an.qs) + '&ames_sin=' + encodeURIComponent(s.an.nota.da);
      return routesSearch(s.q);
    }
    function righeNuove(s) {
      const out = [];
      const q = s.q;
      if (s.cod && s.cod.prodotti.length) {
        out.push('<div class="asd__section asd__section--cod"><h4>' + esc(s.cod.esatto ? TXT.cod : TXT.codp + ' ' + s.cod.codice) + '</h4>'
          + s.cod.prodotti.map(function (p) {
              var th = p.i ? '<img class="asd__thumb" src="' + esc(p.i) + '" alt="" width="44" height="44" loading="lazy">' : '<span class="asd__thumb asd__thumb--ph"></span>';
              return '<a class="asd__item asd__item--prod asd__item--cod" href="' + esc(p.u) + '"><span class="asd__item__media">' + th + '</span>'
                + '<span class="asd__item__body"><span class="asd__item__title">' + esc(p.t) + '</span>'
                + '<div class="asd__item__meta">' + esc([p.v, p.s].filter(Boolean).join(' · ')) + '</div></span></a>';
            }).join('') + '</div>');
      }
      if (s.an && s.an.nota) {
        out.push('<div class="asd__nota">' + esc(TXT.per) + ' <strong>' + esc(s.an.qs) + '</strong>: ' + esc(TXT.scritto)
          + ' <em>' + esc(s.an.nota.da) + '</em> · <a href="' + esc(routesSearch(s.an.nota.da) + '&ames_forza=1') + '">' + esc(TXT.proprio) + ' “' + esc(s.an.nota.da) + '”</a></div>');
      }
      const righe = [];
      const vm = IDX.marchio(q);
      if (vm) righe.push('<a class="asd__item asd__item--cat" href="' + esc(loc('/collections/' + vm.h)) + '"><span class="asd__item__title">'
        + esc(TXT.tutti) + ' <strong>' + esc(vm.name) + '</strong></span><span class="asd__item__badge">' + (vm.n || '') + '</span></a>');
      const viste = {};
      (s.an && s.an.intenti || []).forEach(function (it) {
        (it.categorie || []).forEach(function (h) {
          var c = IDX.collezione(h);
          if (!c || viste[h]) return;
          viste[h] = 1;
          righe.push('<a class="asd__item asd__item--cat" href="' + esc(loc('/collections/' + h)) + '"><span class="asd__item__title">'
            + (it.etichetta ? '<small>' + esc(it.etichetta) + '</small> ' : '') + '<strong>' + esc(c.t) + '</strong></span><span class="asd__item__badge">' + (c.n || '') + '</span></a>');
        });
      });
      const vuota = debole(s);
      /* da risultati che non c'entrano ("xqzwk") non si ricavano categorie */
      if (s.tuttiArrivato && s.tutti && !vuota) {
        IDX.categorie(s.tutti.products).forEach(function (c) {
          if (viste[c.h]) return;
          viste[c.h] = 1;
          righe.push('<a class="asd__item asd__item--cat" href="' + esc(loc('/collections/' + c.h)) + '"><span class="asd__item__title">'
            + esc(q) + ' <span class="asd__in">→</span> <strong>' + esc(c.t) + '</strong></span></a>');
        });
      }
      if (righe.length) out.push('<div class="asd__section asd__section--cat"><h4>' + esc(TXT.cat) + '</h4>' + righe.slice(0, 4).join('') + '</div>');
      if (vuota) out.push(rigaProcura(q));
      return out;
    }

    function section(title, items) {
      return `<div class="asd__section"><h4>${title}</h4>${items.join('')}</div>`;
    }
    function itemA(title, meta, url, badge) {
      return `<a class="asd__item" href="${url}">
        <span class="asd__item__title">${esc(title)}
          ${meta ? `<div class="asd__item__meta">${esc(meta)}</div>` : ''}
        </span>
        ${badge ? `<span class="asd__item__badge">${badge}</span>` : ''}
      </a>`;
    }
    // Chip delle collezioni di appartenenza, derivate dai tag del prodotto.
    // Ordine: categoria (blu) → professione/mestiere (verde) → settore (arancio). Max 4.
    // Chip = span (non <a>, per non annidare anchor dentro l'<a> dell'item).
    // Click: ferma la propagazione e naviga alla collezione.
    function chip(cls, href, label) {
      return '<span class="asd__collchip ' + cls + '" role="link" tabindex="0" data-href="' + esc(href) + '"'
        + ' onclick="event.stopPropagation();event.preventDefault();window.location.href=this.getAttribute(\'data-href\')">'
        + esc(label) + '</span>';
    }
    function collChips(tags) {
      if (!tags || !tags.length || !collMap) return '';
      var cat = [], pro = [], set = [], seen = {};
      tags.forEach(function (t) {
        var m = collMap[t];
        if (!m || seen[m.h]) return;
        seen[m.h] = 1;
        if (t.indexOf('professione:') === 0) pro.push(chip('asd__collchip--pro', loc('/collections/' + m.h), m.t.replace('Attrezzatura per ', '')));
        else if (t.indexOf('settore-macro:') === 0) set.push(chip('asd__collchip--set', loc('/collections/' + m.h), m.t.replace('Forniture per il Settore ', '')));
        else if (t.indexOf(':') === -1) cat.push(chip('', loc('/collections/' + m.h), m.t));
      });
      var chips = cat.concat(pro, set).slice(0, 4);
      return chips.length ? '<span class="asd__collchips">' + chips.join('') + '</span>' : '';
    }
    // Item prodotto con miniatura + chip collezioni.
    function itemProduct(p) {
      var thumb = p.image
        ? '<img class="asd__thumb" src="' + esc(/[?&]width=/.test(p.image) ? p.image : p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=176') + '" alt="" loading="lazy" width="44" height="44">'
        : '<span class="asd__thumb asd__thumb--ph"></span>';
      var meta = [p.vendor, (p.mx || IDX.IT) ? (p.type || p.product_type) : '', p.sku].filter(Boolean).join(' · ');   /* il tipo di Shopify esiste solo in italiano; quello del motore e' tradotto */
      /* Gli accessori arrivano gia' con il risultato (templates/search.sugg.liquid
         li porta): il comando sta FUORI dal link, altrimenti aprirebbe il
         prodotto invece del pannello. */
      /* Niente pastiglie dei mestieri ne' pulsante "Accessori" nella tendina (20/10/2026):
         su telefono ogni prodotto prendeva mezzo schermo. Restano nella scheda. */
      var acc = '';
      return '<div class="asd__prodwrap">'
        + '<a class="asd__item asd__item--prod" href="' + p.url + '">'
        + '<span class="asd__item__media">' + thumb + '</span>'
        + '<span class="asd__item__body">'
        + '<span class="asd__item__title">' + esc(p.title) + '</span>'
        + (meta ? '<div class="asd__item__meta">' + esc(meta) + '</div>' : '')
        + '</span>'
        + '</a>' + acc
        + '</div>';
    }
    function showRecent() {
      const list = window.AMES_RECENT.all();
      if (!list.length) { hide(); return; }
      lastQuery = '';
      inner.innerHTML =
        '<div class="asd__section asd__section--recent">'
        + '<h4>' + esc(T('recent_title', 'Ricerche recenti'))
        + '<button type="button" class="asd__recent-clear" data-recent-clear>'
        + esc(T('recent_clear', 'Cancella')) + '</button></h4>'
        + '<div class="asd__pills">'
        + list.map(function (q) {
            return '<a class="asd__pill" href="' + esc(routesSearch(q)) + '" data-recent-q="'
                 + esc(q) + '">' + esc(q) + '</a>';
          }).join('')
        + '</div></div>';
      show();
    }

    inner.addEventListener('click', function (e) {
      if (e.target.closest('[data-recent-clear]')) {
        e.preventDefault();
        window.AMES_RECENT.clear();
        hide();
        input.focus();
      }
    });

    /* ── Modalita' ricerca ────────────────────────────────────────────────
       Appena si scrive, la barra si stacca e sale in cima allo schermo e il
       pannello dei risultati prende tutta l'altezza rimasta. Prima il pannello
       era alto al massimo 640px e largo quanto il campo: su una ricerca con
       prodotti, categorie e risposte rapide si vedevano tre voci per volta, e
       il resto stava in uno scorrimento dentro lo scorrimento della pagina.

       Il velo dietro serve a due cose: dice che la pagina sotto e' in pausa, e
       da' un punto qualunque dove toccare per uscire. Si esce anche con Esc.
       Il corpo si blocca perche' altrimenti la pagina scorre sotto al pannello
       mentre si legge. */
    var scrim = null;
    var alzati = [];   /* antenati a cui abbiamo alzato lo z-index, per rimetterlo */

    /* PERCHE' NON SI SPOSTA PIU' IL FORM.
       Prima, all'apertura, il form veniva spostato in fondo al corpo della
       pagina per uscire dal contesto di impilamento del contenitore che lo
       ospita. Funzionava per l'impilamento e rompeva la cosa piu' importante:
       spostare nel DOM un campo che ha il fuoco glielo fa perdere, in ogni
       browser. Il risultato era che al secondo carattere — la soglia a cui si
       apre il pannello — la tastiera smetteva di scrivere, e sul telefono si
       chiudeva pure. Un difetto che valeva molto piu' di quanto valesse il
       pannello a tutto schermo.

       Ora il form resta dov'e' e si alza temporaneamente lo z-index degli
       antenati che creano un contesto di impilamento (sulla home e'
       .ames-hero__inner, che ha z-index 3). Alla chiusura si rimette tutto
       com'era. Il fuoco non viene mai toccato. */
    function alzaAntenati(el) {
      var e = el.parentElement;
      while (e && e !== document.body) {
        var st = getComputedStyle(e);
        if ((st.zIndex !== 'auto' || st.position !== 'static') && !e.hasAttribute('data-ames-z')) {
          e.setAttribute('data-ames-z', e.style.zIndex || '');
          e.setAttribute('data-ames-pos', e.style.position || '');
          alzati.push(e);
          e.style.zIndex = '9001';
          if (st.position === 'static') e.style.position = 'relative';
        }
        e = e.parentElement;
      }
    }
    function rimettiAntenati() {
      alzati.forEach(function (e) {
        e.style.zIndex = e.getAttribute('data-ames-z') || '';
        e.style.position = e.getAttribute('data-ames-pos') || '';
        e.removeAttribute('data-ames-z');
        e.removeAttribute('data-ames-pos');
      });
      alzati = [];
    }

    function modalitaRicerca(attiva) {
      var html = document.documentElement;
      if (attiva) {
        if (html.classList.contains('is-ricerca')) return;
        alzaAntenati(form);
        html.classList.add('is-ricerca');
        form.classList.add('is-attiva');
        if (!scrim) {
          scrim = document.createElement('div');
          scrim.className = 'ames-ricerca-velo';
          /* mousedown con preventDefault: chiude senza togliere il fuoco al
             campo, cosi' chi tocca fuori per sbaglio puo' continuare a
             scrivere. */
          scrim.addEventListener('mousedown', function (e) { e.preventDefault(); hide(); });
          document.body.appendChild(scrim);
        }
        scrim.hidden = false;
      } else {
        html.classList.remove('is-ricerca');
        form.classList.remove('is-attiva');
        if (scrim) scrim.hidden = true;
        rimettiAntenati();
      }
    }

    const istanza = { hide: function () { hide(); } };
    function show()  {
      if (window.__AMES_ASD_APERTA && window.__AMES_ASD_APERTA !== istanza) window.__AMES_ASD_APERTA.hide();
      window.__AMES_ASD_APERTA = istanza;
      dropdown.removeAttribute('hidden'); input.setAttribute('aria-expanded', 'true'); modalitaRicerca(true);
    }
    function hide()  {
      dropdown.setAttribute('hidden','');
      input.setAttribute('aria-expanded', 'false');
      inner.innerHTML = '';
      lastQuery = '';
      modalitaRicerca(false);
      if (window.__AMES_ASD_APERTA === istanza) window.__AMES_ASD_APERTA = null;
    }

    function esc(s) { return window.AMES.esc(s); }
    function normalize(s) {
      return String(s || '').toLowerCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9\s]/g, ' ')      // punteggiatura -> spazio ("vendete?" matcha "vendete")
        .replace(/\s+/g, ' ').trim();
    }
    function routesSearch(q) {
      const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return `${base}search?q=${encodeURIComponent(q)}&type=product,collection,article,page`;
    }
  }

  /* ── Ctrl/Cmd + K, e "/" ───────────────────────────────────────────────
     Su un catalogo la ricerca e' il comando piu' usato: raggiungerla senza
     mouse evita di risalire in cima alla pagina a ogni nuova domanda.
     Se in pagina non c'e' un campo visibile si apre la modale. */
  document.addEventListener('keydown', function (e) {
    const inField = /^(INPUT|TEXTAREA|SELECT)$/.test((e.target.tagName || '')) ||
                    e.target.isContentEditable;
    const isK = (e.metaKey || e.ctrlKey) && (e.key === 'k' || e.key === 'K');
    const isSlash = e.key === '/' && !inField && !e.metaKey && !e.ctrlKey && !e.altKey;
    if (!isK && !isSlash) return;
    const field = Array.from(document.querySelectorAll('[data-ames-search-input]'))
      .find(function (el) { return el.offsetParent !== null; });
    e.preventDefault();
    if (field) { field.focus(); field.select(); }
    else if (window.AMES_SEARCH_MODAL && window.AMES_SEARCH_MODAL.open) window.AMES_SEARCH_MODAL.open();
  });
})();
